import React, { createContext, useContext, useState } from "react";

const CustomerContext = createContext();

export const useCustomer = () => useContext(CustomerContext);

export const CustomerProvider = ({ children }) => {

  const initialCustomerData = {
    title: "",
    firstname: "",
    lastname: "",
    email: "",
    profession: "",
    phoneCode: "",
    phoneNo: "",
    address: "",
    postalCode: "",
    city: "",
    state: "",
    countryCode: "",
    enable2FA: false,
    dateOfBirth: "",
    walletCurrency: "",
    openingCashBalance: "",
    openingDueBalance: "",
    isActive: "",
  };

  const [customerData, setCustomerData] = useState(initialCustomerData);

  const resetCustomerData = () => {
    setCustomerData(initialCustomerData);
  };

  return (
    <CustomerContext.Provider
      value={{ customerData, setCustomerData, resetCustomerData }}
    >
      {children}
    </CustomerContext.Provider>
  );
};
